const INITIAL_STATE = { d2dRates: [] };

const setD2DRatesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_D2D_RATES":
      return { ...state, d2dRates: [...action.payload] };
    case "UPLOAD_D2D_RATES":
      return {
        ...state,
        d2dRates: [...state.d2dRates, action.payload],
      };
    // Replaced in place. Filtering the row out and appending it moved every
    // edited rate to the bottom of the table, so a corrected figure jumped
    // away from where it was read.
    case "UPDATE_D2D_RATES":
      return {
        ...state,
        d2dRates: state.d2dRates.map((productType) =>
          productType.id === action.payload.id ? action.payload : productType
        ),
      };
    case "DELETE_D2D_RATES":
      const updatedD2DRatesArray = state.d2dRates.filter(
        (productType) => productType.id !== action.payload.id
      );
      return {
        ...state,
        d2dRates: [...updatedD2DRatesArray],
      };
    default:
      return state;
  }
};
export default setD2DRatesReducer;
